import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { Box, Button, CardActionArea, CardActions, CardHeader, Container, Grid, ImageList } from '@mui/material';
import news1 from '../../media/rsz1.png';
import news2 from '../../media/rsz2.png';
import news3 from '../../media/rsz3.jpg';
import { useState } from 'react';
import { getContentBySortOrder } from '../../services/content-service'
import { useEffect } from 'react';
import './featured-story.css';
import { Link, useNavigate } from 'react-router-dom'
import { AppRoutes } from '../../consts/routes/app-routes';

const FeaturedStory = () => {
    const [data, setData] = useState([]);

    useEffect(() => {
        getContentBySortOrder().then(res => setData(res)).catch(error => console.log(error))
    }, []);

    return (
        <div className="local-impact-container">
            <Typography variant="h4" color="text.secondary" textAlign="center" my={1.5}>
                News
            </Typography>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-around', gap: 2 }} >
                {data.map((item) => (
                    <Box key={item.id} sx={{ width: { xs: '80%', sm: '45%', md: '30%' }, display: 'flex' }}>
                        <Card sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                            <CardActionArea sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                                {item.image && (
                                    <CardMedia
                                        component="img"
                                        height="200"
                                        // image={`data:image/png;base64,${item.image}`}
                                        image={`${item.image_url}`}
                                        alt={item.title}
                                        className="image-for-content"
                                    />
                                )}
                                <CardContent sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
                                    <Typography gutterBottom variant="h5" component="div" textAlign="center" className="content-element">
                                        {item.title}
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary" textAlign="justify" className="content-element"
                                        sx={{ overflowWrap: 'break-word', wordBreak: 'break-word' }}>
                                        {item.synopsis}
                                    </Typography>
                                    <Box sx={{ mt: '20px' }}>
                                        <Link style={{ fontSize: 'large' }} to={`${AppRoutes.Story}/${item.slug}`}>Learn more</Link>
                                    </Box>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Box>
                ))}
            </Box>
        </div>
    );
}

export default FeaturedStory;